import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ProfileBillsAddPageModule } from '../profile-bills-add/profile-bills-add.module';
import { BillingSelectionComponent } from './billing-selection.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ProfileBillsAddPageModule],
  declarations: [BillingSelectionComponent],
})
export class BillingSelectionModule {}
